"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseAPIService_1 = require("./BaseAPIService");
const Services_1 = require("./Services");
class OrganisationService extends BaseAPIService_1.default {
    constructor(baseURL, token) {
        super(baseURL, 'organisation', token);
    }
    charge(id) {
        return new Services_1.OrganisationChargeService(this.baseURL, this.token, id);
    }
    metricMonthly(id) {
        return new Services_1.OrganisationMetricMonthlyService(this.baseURL, this.token, id);
    }
    metricDaily(id) {
        return new Services_1.OrganisationMetricDailyService(this.baseURL, this.token, id);
    }
    chargeUtil(id) {
        return new Services_1.OrganisationChargeUtilService(this.baseURL, this.token, id);
    }
    addRole(orgId, roleId) {
        return super.post(`${orgId}/role/${roleId}`, undefined);
    }
    removeRole(orgId, roleId) {
        return super.deleteWithReturn(`${orgId}/role/${roleId}`);
    }
}
exports.default = OrganisationService;
